import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Papa from "papaparse";
import {
  getDataTypes,
  getMetadataDescription,
} from "../../../../../../features/chatbots/chatbotSlice";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomInput from "../../../../../../Components/Input/CustomInput";
import {
  CheckCircle,
  Clear,
  Delete,
  EditNote,
  ExpandMore,
} from "@mui/icons-material";
import {
  btnStyles,
  inputStyles,
  menuContainerStyles,
  menuItemStyles,
  selectBaseStyles,
  tableCellStyleBody,
  tableCellStyleHeader,
  tableContainerStyles,
  textfieldLayout,
} from "./UploadDatasetsNodeStyles";
import colors from "../../../../../../Constants/colors";
import {
  deleteDataset,
  getDataset,
  saveDataset,
} from "../../../../../../utils/IndexedDBDexieUtility";
import { updateLocalStorage } from "../../../../AppDrawerNav";
import { sendBugReport } from "../../../../../../utils/sendBugReport";
import { generateID } from "../../../../../../utils/informationUtility";
import csvIcon from "../../../../../../Assets/csv.png";
import markdown from "../../../../../../Assets/markdown.png";
import excelIcon from "../../../../../../Assets/excel.png";
import txtIcon from "../../../../../../Assets/txt-file-symbol.png";
import pdfIcon from "../../../../../../Assets/pdf.png";
import docx from "../../../../../../Assets/docx-file-format-symbol.png";
import urlIcon from "../../../../../../Assets/url_icon.png";
import { debounce } from "lodash";
import {
  childNodeNavText,
  datasetNodeStyles,
  fileNodeInputStyles,
  inputsFileFolderCustomStyles,
  inputsFileFolderStyles,
  nodeInputStyles,
  nodeStyles,
  selectCustomstyles,
  topNavNode,
  topNavNodeHidden,
  topNavNodeText,
  viewDatasetsStyles,
} from "../GeneralNodeStyles";
import theme, { createLLMTypography } from "../../../../../../Constants/theme";
import {
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../../../../Constants/buttonStyles";
import TextToNoSQLDialog from "./TextToNoSQLDialog";
import {
  getColumnDefaultType,
  parseExcelData,
  validateCSV,
} from "../../../../../../utils/utilityFunctions";

import { inputStyles as inputSelectStyles } from "../../../../../../Constants/inputStyles";
import { dialogStyles } from "../../../../../../Constants/dialogStyles";
function UploadDatasetsNode({ data, hidden }) {
  const organization = useSelector((state) => state.organization);
  const { user } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const [data_, setData] = useState(data.botData); // local usestate for botdata
  const [csvData, setCsvData] = useState({}); // used in table for view datasets
  const [columnTypes, setColumnTypes] = useState(
    data.botData.columnTypes || {}
  );
  const [dataset, setDataset] = useState(
    data.botData?.structured_datasets[0]?.name || ""
  ); // stores names in view datasets options select in structured

  const [openDatasetModal, setOpenDatasetModal] = useState(false); // open view datasets dialog
  const [currentFileNumber, setCurrentFileNumber] = useState(0); // view datasets index structured

  const [openConfid, setOpenConfid] = useState(false); // state to store confid of file/files uplaoded
  const [openDT, setOpenDT] = useState(false); // state to store current datatype
  const confidRef = useRef(null);
  const confidDTRef = useRef(null);

  const [metadataDescription, setMedataDescriptions] = useState({}); // view datasets - for uns+m files metasata desc
  const [generateMetadataLoading, setGenerateMetadataLoading] = useState(false); // view datasets - for uns+m files metadata desc loader

  const [uploadDatasetLoading, setUploadDatasetLoading] = useState(false); // loader to show file/files upload

  const [isText2NoSQLOptionDisabled, setIsText2NoSQLOptionDisabled] =
    useState(false);

  // states for url scraper
  const [urls, setUrls] = useState([]);
  const [newUrl, setNewUrl] = useState("");
  const [depth, setDepth] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState("");
  const [validateUrlLoading, setValidateUrlLoading] = useState(false);
  const userId = user?.user?._id?.["$oid"];

  // ref for metadata desc textfields
  const textAreaRef = useRef(null);

  // reset state for custom inputs clearing
  const [resetInput, setResetInput] = useState(false);
  // custom input files ref
  const fileInputRef = useRef(null);
  // custom input folder ref
  const folderInputRef = useRef(null);

  // text2nosql restrictions
  const [pendingStructuredFiles, setPendingStructuredFiles] = useState([]);

  // text2nosql select menu open/close state
  const [isText2NoSQLSelectOpen, setIsText2NoSQLSelectOpen] = useState(false);

  // set text2nosql select option from localstorage
  const [selectedText2NoSQLOption, setSelectedText2NoSQLOption] = useState(
    () => {
      const storedText2NoSQL = JSON.parse(
        localStorage.getItem(`text2nosql_${data.nodeId}`) || "false"
      );
      const storedText2NoSQLVectorSearch = JSON.parse(
        localStorage.getItem(`text2nosql-vectorsearch_${data.nodeId}`) ||
          "false"
      );

      if (storedText2NoSQL && storedText2NoSQLVectorSearch) return "both";
      if (storedText2NoSQL) return "text2nosql";
      return "similaritySearch";
    }
  );

  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] =
    useState(false);
  const text2NoSQLSelectRef = useRef(null);

  // states for editing text to no sql prompt
  const [isPromptDialogOpen, setIsPromptDialogOpen] = useState(false);

  // UseEffect to set the initial URL state
  useEffect(() => {
    // Filter datasets where scrapper is true
    const scrapperDatasets = data_?.datasets?.filter(
      (dataset) => dataset.scrapper === true
    );

    // Extract filenames (URLs) and store them in state
    if (scrapperDatasets.length > 0) {
      setUrls(scrapperDatasets.map((dataset) => dataset.fileName)); // Store multiple URLs
      setIsValid(true);
    } else {
      setUrls([]); // Reset if no URLs are found
    }
  }, [data_?.datasets]); // Runs when datasets are updated

  useEffect(() => {
    let mounted = true; // Flag to track if component is mounted

    const loadData = async () => {
      if (!mounted) return; // Don't load if component unmounted

      try {
        const structured_datasets =
          JSON.parse(await getDataset(`structured_datasets_${data.nodeId}`)) ||
          [];
        const datasets =
          JSON.parse(await getDataset(`datasets_${data.nodeId}`)) || [];
        const _columnTypes_ =
          JSON.parse(await getDataset(`columnTypes_${data.nodeId}`)) || {};
        const _unstructured_columnTypes_ =
          JSON.parse(
            await getDataset(`unstructured_columnTypes_${data.nodeId}`)
          ) || {};
        const _csvData_ =
          JSON.parse(await getDataset(`csvData_${data.nodeId}`)) || {};
        const _dataset_ =
          (await getDataset(`dataset_${data.nodeId}`))?.replaceAll('"', "") ||
          "";

        if (!mounted) return; // Check again before setState operations

        // Unstructured Column Types
        if (
          _unstructured_columnTypes_ &&
          Object.keys(_unstructured_columnTypes_).length > 0 &&
          JSON.stringify(_unstructured_columnTypes_) !==
            JSON.stringify(data_.unstructuredColumnTypes)
        ) {
          setColumnTypes(_unstructured_columnTypes_);
          setData((prevData) => ({
            ...prevData,
            unstructuredColumnTypes: _unstructured_columnTypes_,
          }));
        }

        // Dataset
        if (_dataset_ && _dataset_.length > 0 && _dataset_ !== dataset) {
          setDataset(_dataset_);
        }

        // Column Types
        if (
          _columnTypes_ &&
          Object.keys(_columnTypes_).length > 0 &&
          _columnTypes_ !== JSON.stringify(columnTypes)
        ) {
          setData((prevData) => ({
            ...prevData,
            columnTypes: _columnTypes_,
          }));
          setColumnTypes(_columnTypes_);
        }

        // CSV Data
        if (
          _csvData_ &&
          Object.keys(_csvData_).length > 0 &&
          JSON.stringify(_csvData_) !== JSON.stringify(csvData)
        ) {
          setCsvData(_csvData_);
        }

        // Structured Datasets
        if (
          structured_datasets &&
          structured_datasets.length === data_.structured_datasets.length
        ) {
          //do nothing
        } else if (
          structured_datasets &&
          structured_datasets.length > 0 &&
          structured_datasets.length > data_.structured_datasets.length
        ) {
          setData((prevData) => ({
            ...prevData,
            structured_datasets: structured_datasets,
          }));
        } else if (
          structured_datasets &&
          structured_datasets.length > 0 &&
          structured_datasets.length < data_.structured_datasets.length
        ) {
          await saveDataset(
            `structured_datasets_${data.nodeId}`,
            JSON.stringify(data_.structured_datasets)
          );
        }

        // Datasets
        if (
          datasets &&
          datasets.length > 0 &&
          datasets.length > data_.datasets.length
        ) {
          setData((prevData) => ({
            ...prevData,
            datasets: datasets,
          }));
        } else if (
          datasets &&
          datasets.length > 0 &&
          datasets.length < data_.datasets.length
        ) {
          await saveDataset(
            `datasets_${data.nodeId}`,
            JSON.stringify(data_.datasets)
          );
        }

        // Metadata Descriptions
        const _metadataDescriptions_ = JSON.parse(
          localStorage.getItem(`metadataDescriptions_${data.nodeId}`)
        );
        if (
          _metadataDescriptions_ &&
          JSON.stringify(metadataDescription) !==
            JSON.stringify(_metadataDescriptions_)
        ) {
          setMedataDescriptions(_metadataDescriptions_);
          setData((prevData) => ({
            ...prevData,
            metadataDescription: _metadataDescriptions_,
          }));
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadData();

    // Cleanup function
    return () => {
      mounted = false; // Set flag to false when component unmounts
    };
  }, [data_, setData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (confidRef.current && openConfid) {
        setOpenConfid(false);
        confidRef.current = null;
      }
      if (confidDTRef.current && openDT) {
        setOpenDT(false);
        confidDTRef.current = null;
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [size, setSize] = useState("med");

  const dialogProps = {
    small: {
      fullWidth: true,
      maxWidth: "sm",
      fullScreen: false,
    },
    med: {
      fullWidth: true,
      maxWidth: "md",
      fullScreen: false,
    },
    full: {
      fullWidth: false,
      maxWidth: "xl",
      fullScreen: true,
    },
  };

  useEffect(() => {
    if (openConfid && confidRef.current) confidRef.current.focus();
    if (openDT && confidDTRef.current) confidDTRef.current.focus();
  }, [openConfid, openDT]);

  const handleText2NoSQLSelectClick = () => {
    const isOpen = isText2NoSQLSelectOpen;
    setIsText2NoSQLSelectOpen(!isOpen);
    if (isOpen) {
      text2NoSQLSelectRef.current.focus();
    }
  };

  const handleText2NoSQLChange = (event) => {
    if (event.target.value) {
      const value = event.target.value;

      // check the count of structured files
      const structuredFilesCount = data_?.structured_datasets?.length || 0;
      const isDisabled = structuredFilesCount > 1;

      setIsText2NoSQLOptionDisabled(isDisabled);

      if (value === "text2nosql" && isDisabled) {
        setIsConfirmationDialogOpen(true);
        return;
      }
      setSelectedText2NoSQLOption(value);

      const text2nosql = value === "text2nosql" || value === "both";
      const text2nosqlVectorSearch =
        value === "similaritySearch" || value === "both";

      setData((prevData) => ({
        ...prevData,
        text2nosql,
        "text2nosql-vectorsearch": text2nosqlVectorSearch,
      }));

      data.setBotData((prevData) => ({
        ...prevData,
        text2nosql,
        "text2nosql-vectorsearch": text2nosqlVectorSearch,
      }));

      localStorage.setItem(
        `text2nosql_${data.nodeId}`,
        JSON.stringify(text2nosql)
      );
      localStorage.setItem(
        `text2nosql-vectorsearch_${data.nodeId}`,
        JSON.stringify(text2nosqlVectorSearch)
      );
    }
  };

  const handleConfirmationDialogClose = async (confirm) => {
    try {
      setIsConfirmationDialogOpen(false);
      if (confirm) {
        // Change the option to "both" to allow multiple uploads.
        setSelectedText2NoSQLOption("both");
        setIsText2NoSQLOptionDisabled(true); // Disable the "text2nosql" option
        handleText2NoSQLChange({ target: { value: "both" } });
        if (pendingStructuredFiles.length > 0) {
          // Simulate re-invoking the structured upload with pending files.
          const fakeEvent = { target: { files: pendingStructuredFiles } };
          setPendingStructuredFiles([]);
          await handleUploadStructured(fakeEvent);
        }
      } else {
        // If canceled, do not process extra files.
        data.showSnackbar(
          "Extra structured files were not uploaded due to mode restrictions."
        );
        setPendingStructuredFiles([]);
      }
    } catch (error) {
      console.error("Error in handleConfirmationDialogClose:", error);
      data.showSnackbar(
        "An error occurred while processing your request.",
        "error"
      );
    }
  };

  const validateURLFormat = (input) => {
    const urlRegex = /^(https?:\/\/)([\w.-]+)(:\d+)?(\/[^\s]*)?$/;
    return urlRegex.test(input);
  };

  const pingURL = useCallback(
    debounce(async (input) => {
      setValidateUrlLoading(true);
      setIsValid(false);
      setError("");

      try {
        // Use HEAD method to "ping" the URL
        const response = await fetch(input, {
          method: "HEAD",
          mode: "no-cors",
        });

        // Mark as valid if the request succeeds (CORS errors will still trigger catch)
        setIsValid(true);
        setError("");
      } catch (err) {
        setError("Unable to reach the URL. Please check the URL.");
      } finally {
        setValidateUrlLoading(false);
      }
    }, 500), // Debounce with a 500ms delay
    []
  );

  const handleChangeUrl = (e) => {
    const input = e.target.value;
    setNewUrl(input);

    if (validateURLFormat(input)) {
      pingURL(input);
    } else {
      setError("Invalid URL format. Must start with http:// or https://");
      setIsValid(false);
    }
  };

  const handleChangeUrlDepth = (e) => {
    const value = e.target.value;
    if (value === "") {
      setDepth("");
      setError("");
      return;
    }
    const numericDepth = parseInt(value, 10);
    if (
      organization?.organization?.subscription === "starter" &&
      (isNaN(numericDepth) || numericDepth < 1 || numericDepth > 5)
    ) {
      setError("Depth must be between 1 and 5.");
    } else {
      setError("");
      setDepth(numericDepth);
    }
  };

  const handleChange_unstructured_confidentiality = async (event, filename) => {
    const newConfidentiality = event.target.value;
    if (newConfidentiality) {
      const updatedDatasets = data_.datasets.map((file) => {
        if (file.fileName === filename) {
          return { ...file, confidentiality: newConfidentiality };
        }
        return file;
      });

      setData((prevData) => ({
        ...prevData,
        datasets: updatedDatasets,
      }));

      data.setBotData((prevData) => ({
        ...prevData,
        datasets: updatedDatasets,
      }));

      const key = `datasets_${data.nodeId}`;
      await saveDataset(key, JSON.stringify(updatedDatasets));
    }
  };

  function getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Add 1 because months are zero-based
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleColumnTypeChange = (fileName, header, type) => {
    if (fileName.search("_unstructured") !== -1) {
      const updated = {
        ...columnTypes,
        [fileName]: { ...columnTypes[fileName], [header]: type },
      };
      saveDataset(
        `unstructured_columnTypes_${data.nodeId}`,
        JSON.stringify({ ...updated })
      );

      setColumnTypes((prevTypes) => ({ ...updated }));
      setData((prevData) => ({
        ...prevData,
        unstructuredColumnTypes: { ...updated },
      }));
      data.setBotData((prevData) => ({
        ...prevData,
        unstructuredColumnTypes: { ...updated },
      }));
    } else {
      const updated = {
        ...columnTypes,
        [fileName]: { ...columnTypes[fileName], [header]: type },
      };
      saveDataset(`columnTypes_${data.nodeId}`, JSON.stringify(updated));

      setColumnTypes((prevTypes) => updated);

      setData((prevData) => ({
        ...prevData,
        columnTypes: {
          ...updated,
        },
      }));
      data.setBotData((prevData) => ({
        ...prevData,
        columnTypes: {
          ...updated,
        },
      }));
    }
  };

  const getHeaders = (file) =>
    new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        preview: 1,
        complete: (result) => {
          const hdrs = Object.keys(result.data[0] || {});
          resolve(hdrs);
        },
        error: (err) => reject(err),
      });
    });

  const handleUpload = async (e) => {
    const files = e?.target?.files || [e];
    if (!files || files.length === 0) {
      return;
    }
    const files_ = e?.target?.files ? Array.from(e.target.files) : [e];

    const exists_un = files_.some((file) =>
      data_.datasets.some((dataset) => dataset.fileName === file.name)
    );
    const exists_unm = files_.some((file) =>
      data_.structured_datasets.some(
        (dataset) => dataset.fileName === file.name
      )
    );
    if (exists_un || exists_unm) {
      data.showSnackbar("You cannot upload files with same names.", "error");
      return;
    }

    setUploadDatasetLoading(true);
    data.showSnackbar("Uploading datasets please wait.", "info", 2000);

    const datasetLength =
      data_.datasets.length + data_.structured_datasets.length + files.length;

    if (
      datasetLength > 5 &&
      organization?.organization?.subscription === "starter"
    ) {
      data.showSnackbar(
        "Upload limit exceeded! The Starter plan allows a maximum of 5 files. Please remove some files or upgrade your plan to continue.",
        "error"
      );
      setUploadDatasetLoading(false);
      return;
    }

    const totalSize =
      data_.datasets.reduce(
        (accumulator, dataset) =>
          dataset.fileSize ? accumulator + dataset.fileSize : accumulator,
        0
      ) +
      data_.structured_datasets.reduce(
        (accumulator, dataset) =>
          dataset.fileSize ? accumulator + dataset.fileSize : accumulator,
        0
      );

    if (
      totalSize > 5 &&
      organization?.organization?.subscription === "starter"
    ) {
      data.showSnackbar(
        "The total file size exceeds 5MB. Please reduce the file size and try again!",
        "error"
      );
      setUploadDatasetLoading(false);
      return;
    }

    let fileSizes = [];
    let check = false;
    let _NEWPARSINGINSTRUCTIONS_ = {
      ...data_.parsing_instructions,
    };

    for (let i = 0; i < files.length; i++) {
      setUploadDatasetLoading(true);

      const file = files[i];
      const uniqueId = generateID(8) + "_" + i;
      const fileName = file.name;
      const fileSize = file.size;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      fileSizes.push(fileSize);

      const reader = new FileReader();

      // reader.onload = async (event) => {

      // const size = parseFloat(
      //   fileSizes.reduce(
      //     (accumulator, currentValue) => accumulator + currentValue,
      //     0
      //   ) /
      //     (1024 * 1024)
      // );
      //}
      if (
        (file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/pdf" ||
          file.type === "text/plain" ||
          file.type === "text/markdown" ||
          file.type === "text/x-markdown" ||
          (!file.type && fileExtension === "md")) &&
        dataType === "Unstructured"
      ) {
        const key = `datasets_${data.nodeId}`;

        const newDataset = {
          filedata: file,
          file: file,
          id: uniqueId,
          fileName: fileName,
          fileType: file.type,
          creationDate: getCurrentDate(),
          category: "",
          confidentiality: confid,
          scrapper: false,
        };

        let _DATASETS_ = [...data_.datasets];

        await _DATASETS_.push(newDataset);

        await saveDataset(key, JSON.stringify([...data_.datasets, newDataset]));

        _NEWPARSINGINSTRUCTIONS_[fileName] = {
          bounding_box: "0,0,0,0",
          mode: "auto",
          title_page_number: "1",
          exclude_title_page: false,
        };

        data.setBotData((prevData) => ({
          ...prevData,
          parsing_instructions: {
            ...prevData.parsing_instructions,
            [fileName]: {
              ...prevData.parsing_instructions[fileName],
              bounding_box: "0,0,0,0",
              mode: "auto",
              title_page_number: "1",
              exclude_title_page: false,
            },
          },
          datasets: [
            ...prevData.datasets,
            {
              filedata: file,
              file: file,
              id: uniqueId,
              fileName: fileName,
              fileType:
                !file.type && fileExtension === "md"
                  ? "text/markdown"
                  : file.type,
              creationDate: getCurrentDate(),
              category: "",
              confidentiality: confid,
              scrapper: false,
            },
          ],
        }));

        setData((prevData) => ({
          ...prevData,
          datasets: [
            ...prevData.datasets,
            {
              filedata: file,
              file: file,
              id: uniqueId,
              fileName: fileName,
              fileType:
                !file.type && fileExtension === "md"
                  ? "text/markdown"
                  : file.type,
              creationDate: getCurrentDate(),
              category: "",
              confidentiality: confid,
              scrapper: false,
            },
          ],
        }));

        const existingInstructions = JSON.parse(
          localStorage.getItem(`parsing_instructions_${data.nodeId}`) || "{}"
        );

        const mergedInstructions = {
          ...existingInstructions,
          ..._NEWPARSINGINSTRUCTIONS_,
        };

        localStorage.setItem(
          `parsing_instructions_${data.nodeId}`,
          JSON.stringify(mergedInstructions)
        );
        // Success message
        data.showSnackbar("Files uploaded successfully", "success");

        setUploadDatasetLoading(false);
      } else {
        if (dataType === "Unstructured") {
          data.showSnackbar(
            "Error: The selected file type is incorrect. Please choose a file with one of the following formats: .txt, .docx, .doc, .md  or .pdf.",
            "error"
          );

          check = true;
          setUploadDatasetLoading(false);

          return;
        }
        if (organization?.organization?.subscription === "starter") {
          data.showSnackbar(
            "Error: Unstructured files with metadata cannot be uploaded in the Starter package. You need to subscribe to Queryloop Pro",
            "error"
          );
          check = true;
          setUploadDatasetLoading(false);

          return;
        }
        // check for existing structured datasets that DO NOT contain "_unstructured" in the file name (or check headers)
        const areExistingStructuredFiles = data_.structured_datasets.filter(
          (file) => !file.fileName.includes("_unstructured")
        );
        if (areExistingStructuredFiles.length > 0) {
          data.showSnackbar(
            "Error: Unstructured files with metadata cannot be uploaded when structured data already exists!",
            "error"
          );

          check = true;
          setUploadDatasetLoading(false);

          return;
        }

        try {
          // Compare every file's headers to the first one's
          const baseHeaders =
            data_?.headers.length > 0
              ? data_?.headers
              : await getHeaders(files[0]);
          for (let i = 0; i < files.length; i++) {
            const hdrs = await getHeaders(files[i]);
            const same =
              hdrs.length === baseHeaders.length &&
              hdrs.every((h) => baseHeaders.includes(h));
            if (!same) {
              data.showSnackbar(
                "Error: All files must share the exact same headers.",
                "error"
              );
              setUploadDatasetLoading(false);
              return;
            }
          }
        } catch (err) {
          console.error("Header parse error:", err);
          data.showSnackbar(
            "Error reading file headers. Please check your files.",
            "error"
          );
          setUploadDatasetLoading(false);

          return;
        }
        // read headers of the current file
        Papa.parse(file, {
          complete: async (result) => {
            const file_data = result.data;
            const headers = Object.keys(file_data[0]);

            setData((prevData) => ({
              // current usestate
              ...prevData,
              headers,
            }));

            data.setBotData((prevData) => ({
              //app.js state
              ...prevData,
              headers,
            }));

            if (check) return;

            const initialColumnTypes = headers.reduce((acc, header) => {
              acc[header] = getColumnDefaultType(file_data, header);
              return acc;
            }, {});

            setColumnTypes((prevData) => ({
              ...prevData,
              [file.name + "_unstructured"]: initialColumnTypes,
            }));

            setCsvData((prevData) => ({
              ...prevData,
              [file.name + "_unstructured"]: file_data.slice(0, 3),
            }));

            setData((prevData) => ({
              ...prevData,
              unstructuredColumnTypes: {
                ...prevData.unstructuredColumnTypes,
                [file.name + "_unstructured"]: initialColumnTypes,
              },
              structured_file: file_data.slice(0, 3),
            }));

            data.setBotData((prevData) => ({
              ...prevData,
              unstructuredColumnTypes: {
                ...prevData.unstructuredColumnTypes,
                [file.name + "_unstructured"]: initialColumnTypes,
              },
              structured_file: file_data.slice(0, 3),
            }));

            await saveDataset(
              `unstructured_columnTypes_${data.nodeId}`,
              JSON.stringify({
                ...data.unstructuredColumnTypes,
                [file.name + "_unstructured"]: initialColumnTypes,
              })
            );

            await saveDataset(
              `csvData_${data.nodeId}`,
              JSON.stringify({
                ...csvData,
                [file.name + "_unstructured"]: file_data.slice(0, 3),
              })
            );

            await saveDataset(
              `dataset_${data.nodeId}`,
              JSON.stringify(file.name + "_unstructured")
            );

            const formData = new FormData();
            formData.append("file", file);
            formData.append("fileName", file.name + "_unstructured");
            const dataTypesCSV = await dispatch(getDataTypes(formData));

            if (dataTypesCSV.payload.datatypes) {
              const _ID_ = generateID(8);
              const fileSize = file.size / (1024 * 1024); // Convert to MB
              setData((prevData) => ({
                ...prevData,
                structured_datasets: [
                  ...(Array.isArray(prevData.structured_datasets)
                    ? prevData.structured_datasets
                    : []),
                  {
                    filedata: file,
                    file: file, // Store actual file object
                    id: _ID_,
                    fileName: file.name + "_unstructured",
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    upload_type: "unstructured-metadata",
                    scrapper: false,
                  },
                ],
              }));

              data.setBotData((prevData) => ({
                ...prevData,
                structured_datasets: [
                  ...(Array.isArray(prevData.structured_datasets)
                    ? prevData.structured_datasets
                    : []),
                  {
                    filedata: file,
                    file: file, // Store actual file object,
                    id: _ID_,
                    fileName: file.name + "_unstructured",
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    scrapper: false,
                  },
                ],
              }));
              const structured_datasets =
                JSON.parse(
                  await getDataset(`structured_datasets_${data.nodeId}`)
                ) || [];
              await saveDataset(
                `structured_datasets_${data.nodeId}`,
                JSON.stringify([
                  ...structured_datasets,
                  {
                    filedata: file,
                    file: file, // Store actual file object,
                    id: _ID_,
                    fileName: file.name + "_unstructured",
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    scrapper: false,
                  },
                ])
              );

              setDataset(file.name + "_unstructured");
              data.showSnackbar(
                "You need to generate metadata in 'View Datasets'"
              );
              setTimeout(() => {
                data.showSnackbar("Files uploaded successfully", "success");
              }, 6000);

              setUploadDatasetLoading(false);
            }
          },
          header: true,
        });
        if (check) {
          setUploadDatasetLoading(false);
          return;
        }
      }
      // };
      reader.readAsDataURL(file);
    }

    if (e && e.target) {
      e.target.value = "";
    }
  };

  const handleUploadStructured = async (e) => {
    const files = e?.target?.files || [e];
    if (!files || files.length === 0) {
      return;
    }

    const files_ = e?.target?.files ? Array.from(e.target.files) : [e];

    const exists_st = files_.some((file) =>
      data_.structured_datasets.some(
        (dataset) => dataset.fileName === file.name
      )
    );
    if (exists_st) {
      data.showSnackbar("You cannot upload files with same names.", "error");

      return;
    }

    // Pre-validation for "text2nosql" mode (only one structured file allowed)
    if (selectedText2NoSQLOption === "text2nosql") {
      const existingCount = data_?.structured_datasets?.length || 0;
      if (existingCount >= 1 || files.length > 1) {
        // Save files for processing after confirmation
        setPendingStructuredFiles(files);
        setIsConfirmationDialogOpen(true);
        setUploadDatasetLoading(false);
        return;
      }
    }

    data.showSnackbar("Uploading datasets please wait", "info");
    setUploadDatasetLoading(true);

    const datasetLength =
      data_.datasets.length + data_.structured_datasets.length + files.length;

    if (
      datasetLength > 5 &&
      organization?.organization?.subscription === "starter"
    ) {
      data.showSnackbar(
        "You are trying to add more than five files. Please remove some files or upgrade your plan to continue.",
        "error"
      );
      setUploadDatasetLoading(false);
      return;
    }

    const totalSize =
      data_.datasets.reduce(
        (accumulator, dataset) =>
          dataset.fileSize ? accumulator + dataset.fileSize : accumulator,
        0
      ) +
      data_.structured_datasets.reduce(
        (accumulator, dataset) =>
          dataset.fileSize ? accumulator + dataset.fileSize : accumulator,
        0
      );
    if (
      totalSize > 5 &&
      organization?.organization?.subscription === "starter"
    ) {
      data.showSnackbar(
        "The total file size exceeds 5MB. Please reduce the file size and try again!",
        "error"
      );
      setUploadDatasetLoading(false);
      return;
    }

    let structuredFileCount = data_?.structured_datasets?.length;

    for (const file of files) {
      setUploadDatasetLoading(true);

      const size = file.size / (1024 * 1024); // Convert size to MB
      if (
        size > 0.1 &&
        organization?.organization?.subscription === "starter"
      ) {
        data.showSnackbar(
          "Free version limits structured files to 100 KB. Upgrade to Pro for larger uploads.",
          "error"
        );

        setUploadDatasetLoading(false);

        return;
      }

      if (file.type === "text/csv") {
        const reader = new FileReader();
        structuredFileCount = structuredFileCount + 1;

        reader.readAsText(file); // Read as text for CSV
        reader.onload = async (event) => {
          const fileContent = event.target.result;

          // Use the helper function to check header consistency
          const checkResult = validateCSV(fileContent);

          // Handle error if not enough rows to check
          if (checkResult.error) {
            data.showSnackbar(`${checkResult.error}`, "error");
            setUploadDatasetLoading(false);
            return;
          }

          // If column counts are not consistent, notify the user and abort.
          if (!checkResult.isConsistent) {
            data.showSnackbar(
              "This CSV file has a header row that doesn't match the data columns.",
              "error"
            );
            setUploadDatasetLoading(false);
            return;
          }

          Papa.parse(file, {
            complete: async (result) => {
              const rows = result.data;

              if (rows.length < 2) {
                data.showSnackbar(
                  "The uploaded file does not have sufficient rows to validate headers.",
                  "error"
                );
                setUploadDatasetLoading(false);
                return;
              }

              const file_data = result.data.map((row) =>
                Object.fromEntries(
                  Object.entries(row).map(([key, value]) => [
                    key,
                    value === null || value === "" ? "" : value,
                  ])
                )
              );

              const headers = Object.keys(file_data[0]).filter((item) => {
                return item !== "" && !/^_\d+$/.test(item);
              });

              // check if there is already unstructured data uploaded with metadata
              if (data_.headers.length !== 0) {
                // previous unstructured files with metadata doesnt match current metadata
                if (JSON.stringify(data_.headers) !== JSON.stringify(headers)) {
                  data.showSnackbar(
                    `The metadata of file ${file.name} doesn't match metadata set by unstructured data.`,
                    "error"
                  );
                  setUploadDatasetLoading(false);

                  return;
                }
              }
              // previous unstructured files with metadata matches current metadata or there is no prev metadata
              const initialColumnTypes = headers.reduce((acc, header) => {
                acc[header] = getColumnDefaultType(file_data, header);
                return acc;
              }, {});
              // metadata state set
              setColumnTypes((prevData) => {
                const newData = {
                  ...prevData,
                  [file.name]: initialColumnTypes,
                };

                saveDataset(
                  `columnTypes_${data.nodeId}`,
                  JSON.stringify(newData)
                );

                return newData;
              });

              setCsvData((prevData) => {
                const newData = {
                  ...prevData,
                  [file.name]: file_data.slice(0, 3),
                };
                saveDataset(`csvData_${data.nodeId}`, JSON.stringify(newData));
                return newData;
              });

              setData((prevData) => ({
                ...prevData,
                columnTypes: {
                  ...prevData.columnTypes,
                  [file.name]: initialColumnTypes,
                },
                structured_file: file_data.slice(0, 3),
                // metadata set
              }));
              data.setBotData((prevData) => ({
                ...prevData,
                columnTypes: {
                  ...prevData.columnTypes,
                  [file.name]: initialColumnTypes,
                },
                structured_file: file_data.slice(0, 3),
                // metadata set
              }));

              const formData = new FormData();
              formData.append("file", file);
              formData.append("fileName", file.name);
              const dataTypesCSV = await dispatch(getDataTypes(formData));

              if (dataTypesCSV.payload.datatypes) {
                const _ID_ = generateID(8);
                setData((prevData) => ({
                  ...prevData,
                  structured_datasets: [
                    ...prevData.structured_datasets,
                    {
                      filedata: file,
                      file: file, // Store actual file object
                      id: _ID_,
                      fileName: file.name,
                      fileType: file.type,
                      creationDate: getCurrentDate(),
                      category: "",
                      confidentiality: confid,
                      dataTypes: dataTypesCSV.payload.datatypes,
                      fileSize: size,
                      scrapper: false,
                    },
                  ],
                }));

                data.setBotData((prevData) => ({
                  ...prevData,
                  structured_datasets: [
                    ...prevData.structured_datasets,
                    {
                      filedata: file,
                      file: file, // Store actual file object
                      id: _ID_,
                      fileName: file.name,
                      fileType: file.type,
                      creationDate: getCurrentDate(),
                      category: "",
                      confidentiality: confid,
                      dataTypes: dataTypesCSV.payload.datatypes,
                      fileSize: size,
                      scrapper: false,
                    },
                  ],
                }));

                const structured_datasets =
                  JSON.parse(
                    await getDataset(`structured_datasets_${data.nodeId}`)
                  ) || [];

                await saveDataset(
                  `structured_datasets_${data.nodeId}`,
                  JSON.stringify([
                    ...structured_datasets,
                    {
                      filedata: file,
                      file: file, // Store actual file object
                      id: _ID_,
                      fileName: file.name,
                      fileType: file.type,
                      creationDate: getCurrentDate(),
                      category: "",
                      confidentiality: confid,
                      dataTypes: dataTypesCSV.payload.datatypes,
                      fileSize: size,
                      scrapper: false,
                    },
                  ])
                );
                setDataset(file.name);
                await saveDataset(
                  `dataset_${data.nodeId}`,
                  JSON.stringify(file.name)
                );
                data.showSnackbar("File uploaded successfully", "success");

                setUploadDatasetLoading(false);
              } else {
                data.showSnackbar(
                  "Unable to upload File successfully.",
                  "error"
                );

                setUploadDatasetLoading(false);
              }
            },
            header: true,
          });
        };
      } else if (
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel"
      ) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file); // Read as array buffer for Excel (xlsx)
        reader.onload = async (event) => {
          const sheetsData = await parseExcelData(
            event.target.result,
            setUploadDatasetLoading,
            data
          );
          let sheetNumber = 1;

          const newCsvData = { ...csvData };
          const newColumnTypes = { ...columnTypes };

          for (const sheetName in sheetsData) {
            setUploadDatasetLoading(true);
            structuredFileCount = structuredFileCount + 1;

            const { file_data, headers, columnTypes, formatted_data } =
              sheetsData[sheetName];
            const newFileName = `${file.name.replace(
              ".xlsx",
              ""
            )}_${sheetName}.csv`;
            // check if there is already unstructured data uploaded with metadata
            if (data_.headers.length !== 0) {
              // previous unstructured files with metadata doesnt match current metadata
              if (JSON.stringify(data_.headers) !== JSON.stringify(headers)) {
                data.showSnackbar(
                  `The metadata of file ${newFileName} doesn't match metadata set by unstructured data.`,
                  "error"
                );
                setUploadDatasetLoading(false);

                return;
              }
            }
            // previous unstructured files with metadata matches current metadata or there is no prev metadata
            // setColumnTypes((prevData) => ({
            //   ...prevData,
            //   [newFileName]: columnTypes,
            // }));

            // saveDataset(
            //   `columnTypes_${data.nodeId}`,
            //   JSON.stringify({
            //     ...columnTypes,
            //     [newFileName]: columnTypes,
            //   })
            // );
            newColumnTypes[newFileName] = columnTypes;
            newCsvData[newFileName] = file_data.slice(0, 3);

            setData((prevData) => ({
              ...prevData,
              columnTypes: {
                ...prevData.columnTypes,
                [newFileName]: columnTypes,
              },
              structured_file: file_data.slice(0, 3),
            }));
            data.setBotData((prevData) => ({
              ...prevData,
              columnTypes: {
                ...prevData.columnTypes,
                [newFileName]: columnTypes,
              },
              structured_file: file_data.slice(0, 3),
            }));

            // Convert the file_data array to a CSV string
            const csvContent = formatted_data
              .map((row) => row.join(","))
              .join("\n");
            // Create a Blob from the CSV string
            const blob = new Blob([csvContent], { type: "text/csv" });

            // Create FormData and append the Blob with the new CSV file name
            const formData = new FormData();
            formData.append("file", blob, newFileName);
            formData.append("fileName", newFileName);

            // Send the FormData with the CSV data
            const dataTypesCSV = await dispatch(getDataTypes(formData));

            if (dataTypesCSV?.payload?.datatypes) {
              const _ID_ = generateID(8);

              setData((prevData) => ({
                ...prevData,
                structured_datasets: [
                  ...prevData.structured_datasets,
                  {
                    filedata: blob,
                    file: blob, // Store actual file object
                    id: _ID_,
                    fileName: newFileName,
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    scrapper: false,
                  },
                ],
              }));
              data.setBotData((prevData) => ({
                ...prevData,
                structured_datasets: [
                  ...prevData.structured_datasets,
                  {
                    filedata: blob,
                    file: blob, // Store actual file object
                    id: _ID_,
                    fileName: newFileName,
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    scrapper: false,
                  },
                ],
              }));
              await saveDataset(
                `structured_datasets_${data.nodeId}`,
                JSON.stringify([
                  ...data_.structured_datasets,
                  {
                    filedata: blob,
                    file: blob, // Store actual file object
                    id: _ID_,
                    fileName: newFileName,
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    scrapper: false,
                  },
                ])
              );
              setDataset(newFileName);
              await saveDataset(
                `dataset_${data.nodeId}`,
                JSON.stringify(newFileName)
              );
              sheetNumber++;
              const structured_datasets =
                JSON.parse(
                  await getDataset(`structured_datasets_${data.nodeId}`)
                ) || [];
              await saveDataset(
                `structured_datasets_${data.nodeId}`,
                JSON.stringify([
                  ...structured_datasets,
                  {
                    filedata: blob,
                    file: blob, // Store actual file object
                    id: _ID_,
                    fileName: newFileName,
                    fileType: file.type,
                    creationDate: getCurrentDate(),
                    category: "",
                    confidentiality: confid,
                    dataTypes: dataTypesCSV.payload.datatypes,
                    fileSize: size,
                    scrapper: false,
                  },
                ])
              );
              data.showSnackbar("File uploaded successfully", "success");

              setUploadDatasetLoading(false);
            }
          }
          // Batch update the state once
          saveDataset(`csvData_${data.nodeId}`, JSON.stringify(newCsvData));
          setCsvData(newCsvData);

          // Batch update the state once with all column types
          setColumnTypes(newColumnTypes);
          saveDataset(
            `columnTypes_${data.nodeId}`,
            JSON.stringify(newColumnTypes)
          );
        };

        reader.onerror = () => {
          data.showSnackbar("Unable to read the file.", "error");
          setUploadDatasetLoading(false);
        };
      } else {
        data.showSnackbar(
          `${file.type} is not a supported file type.\nSupported file types are: CSV, xlsx`,
          "error"
        );
        setUploadDatasetLoading(false);

        continue; // Skip unsupported files
      }

      // check the count of structured files
      const isDisabled = structuredFileCount > 1;
      if (selectedText2NoSQLOption === "text2nosql" && isDisabled) {
        setIsConfirmationDialogOpen(true);
        return;
      }

      setIsText2NoSQLOptionDisabled(isDisabled);

      if (e && e.target) {
        e.target.value = "";
      }
    }

    if (e && e.target) {
      e.target.value = "";
    }
  };

  const handleFolderUpload = async (e, upload_type) => {
    setUploadDatasetLoading(true);
    try {
      const files = Array.from(e.target.files);
      const datasetLength =
        data_.datasets.length + data_.structured_datasets.length + files.length;

      if (
        datasetLength > 5 &&
        organization?.organization?.subscription === "starter"
      ) {
        data.showSnackbar(
          "You are trying to add more than five files. Please remove some files or upgrade your plan to continue.",
          "error"
        );
        setUploadDatasetLoading(false);
        return;
      }

      if (
        upload_type === "structured" &&
        selectedText2NoSQLOption === "text2nosql"
      ) {
        const existingCount = data_?.structured_datasets?.length || 0;
        if (existingCount >= 1 || files.length > 1) {
          setPendingStructuredFiles(files);
          setIsConfirmationDialogOpen(true);
          setUploadDatasetLoading(false);
          return;
        }
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const unstructured_file_type_check =
          file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.type === "application/pdf" ||
          file.type === "text/plain" ||
          file.type === "text/markdown" ||
          file.type === "text/x-markdown" ||
          (!file.type && fileExtension === "md");

        if (upload_type === "unstructured" && unstructured_file_type_check) {
          await handleUpload(file);
        } else if (upload_type === "structured") {
          await handleUploadStructured(file);
        } else if (
          upload_type === "unstructured-with-metadata" &&
          !unstructured_file_type_check
        ) {
          await handleUpload(file);
        } else {
          console.warn(
            `File type ${file.type} not supported! for`,
            " File name: ",
            file.name
          );
        }
      }
    } catch (error) {
      console.error("Error: ", error);
    } finally {
      setUploadDatasetLoading(false);
      e.target.value = "";
    }
  };

  const [confid, setConfid] = useState("Public");
  const [dataType, setDataType] = useState("Unstructured");
  const [visibility, setVisibility] = useState("Public");

  const handleChange = (event) => {
    setVisibility(event.target.value);

    const indexOfDataset = data_.structured_datasets.findIndex(
      (_dataset) => _dataset.fileName === dataset
    );

    if (indexOfDataset !== -1) {
      setData((prevData) => ({
        ...prevData,
        structured_datasets: [
          ...prevData.structured_datasets.slice(0, indexOfDataset),
          {
            ...prevData.structured_datasets[indexOfDataset],
            confidentiality: event.target.value,
          },
          ...prevData.structured_datasets.slice(indexOfDataset + 1),
        ],
      }));
      data.setBotData((prevData) => ({
        ...prevData,
        structured_datasets: [
          ...prevData.structured_datasets.slice(0, indexOfDataset),
          {
            ...prevData.structured_datasets[indexOfDataset],
            confidentiality: event.target.value,
          },
          ...prevData.structured_datasets.slice(indexOfDataset + 1),
        ],
      }));
    } else {
      console.error("Dataset not found with filename:", dataset);
    }
  };

  const handleChangeGlobal = (e) => {
    if (e.target.value) {
      setConfid(e.target.value);
    }
  };

  const handleChangeDT = (e) => {
    if (e.target.value) {
      setDataType(e.target.value);
    }
  };

  const confidentialityOptions = [
    { value: "Public", label: "Public" },
    { value: "Confidential", label: "Confidential" },
    { value: "Secret", label: "Secret" },
  ];

  const datasetTypes = [
    { value: "Structured", label: "Structured" },
    { value: "Unstructured", label: "Unstructured" },
    {
      value: "Unstructured with metadata",
      label: "Unstructured with metadata",
    },
    { value: "url_scraper", label: "URL Scraper" },
  ];

  const handleChangeDataset = (event) => {
    const confid = data_.structured_datasets.filter(
      (d) => d.fileName === event.target.value
    )[0].confidentiality;
    const newConfid = confid;

    setVisibility(newConfid);
    setDataset(event.target.value);
    saveDataset(`dataset_${data.nodeId}`, event.target.value);
  };

  const handleChangeMetadataDescription = (event, header) => {
    let updatedMetadataDescriptions = { ...metadataDescription };
    updatedMetadataDescriptions[dataset][header] = {
      type: updatedMetadataDescriptions[dataset][header].type,
      description: event.target.value,
    };
    setData((prevData) => ({
      ...prevData,
      metadataDescription: {
        ...updatedMetadataDescriptions,
      },
    }));
    data.setBotData((prevData) => ({
      ...prevData,
      metadataDescription: {
        ...updatedMetadataDescriptions,
      },
    }));
    localStorage.setItem(
      `metadataDescriptions_${data.nodeId}`,
      JSON.stringify(updatedMetadataDescriptions)
    );
  };

  const handleGenerateMetadata = async () => {
    setGenerateMetadataLoading(true);
    data.showSnackbar("Generating metadata descriptions please wait!");
    if (dataset.includes("_unstructured")) {
      const _DATASET_ = data_.structured_datasets.filter(
        (d) => d.fileName === dataset
      )[0];
      const _UNSTRUCTURED_COLUMN_TYPES_ =
        data_.unstructuredColumnTypes[dataset];

      const fileObj = _DATASET_.filedata || _DATASET_.file;

      const requestData = {
        fileData: fileObj,
        columnTypes: _UNSTRUCTURED_COLUMN_TYPES_,
        filename: dataset,
        userId: userId,
      };
      try {
        const response = await dispatch(getMetadataDescription(requestData));
        setData((prevData) => ({
          ...prevData,
          metadataDescription: {
            ...prevData.metadataDescription,
            [dataset]: response.payload.columnTypes,
          },
        }));
        data.setBotData((prevData) => ({
          ...prevData,
          metadataDescription: {
            ...prevData.metadataDescription,
            [dataset]: response.payload.columnTypes,
          },
        }));
        setMedataDescriptions((prevData) => ({
          ...prevData,
          [dataset]: response.payload.columnTypes,
        }));
        localStorage.setItem(
          `metadataDescriptions_${data.nodeId}`,
          JSON.stringify({
            ...metadataDescription,
            [dataset]: response.payload.columnTypes,
          })
        );
        data.showSnackbar("Metadata descriptions generated", "success");
      } catch (error) {
        data.showSnackbar(
          "Metadata descriptions cannot be generated please try again",
          "error"
        );
        sendBugReport(
          organization?.organization,
          user?.user,
          error,
          "Metadata generation",
          dispatch
        );
      } finally {
        setGenerateMetadataLoading(false);
      }
    }
  };

  const handleFileRemove = (uniqueIdToRemove, fileName) => {
    const updatedDatasets = data_.datasets.filter(
      (file) => file.id !== uniqueIdToRemove
    );

    const key = `parsing_instructions_${data.nodeId}`;
    const existingInstructions = JSON.parse(localStorage.getItem(key) || "{}");

    // Remove the specific file's instructions
    delete existingInstructions[fileName];

    // Update localStorage
    localStorage.setItem(key, JSON.stringify(existingInstructions));

    // Sync state
    const updatedBotData = {
      datasets: updatedDatasets,
      parsing_instructions: existingInstructions,
      golden_responses:
        JSON.parse(localStorage.getItem("golden_responses")) || [],
    };

    deleteDataset(`datasets_${data.nodeId}`, JSON.stringify(updatedDatasets));

    data.setBotData((prevData) => ({ ...prevData, ...updatedBotData }));
    setData((prevData) => ({ ...prevData, ...updatedBotData }));

    setResetInput(true);
    setTimeout(() => setResetInput(false), 100);
  };

  const handleDataTypeChange = (event, header, dataset) => {
    const index = data_.structured_datasets.findIndex(
      (_d) => _d.fileName === dataset
    );

    // Ensure the dataset exists
    if (index !== -1) {
      // Create a copy of the dataset to avoid mutating state directly
      const updatedDataset = { ...data_.structured_datasets[index] };

      // Update the dataTypes object with the new value for the given header
      updatedDataset.dataTypes = {
        ...updatedDataset.dataTypes,
        [header]: event.target.value,
      };

      // Create a new array with the updated dataset
      const updatedDatasets = [...data_.structured_datasets];
      updatedDatasets[index] = updatedDataset;

      // Update the state with the new array of datasets
      setData((prevData) => ({
        ...prevData,
        structured_datasets: updatedDatasets,
      }));

      data.setBotData((prevData) => ({
        ...prevData,
        structured_datasets: updatedDatasets,
      }));
    }
  };

  // add validation when removing unstructured file -> should remove from unstructuredcolumnTypes instead of columnTypes
  const handleStructuredFileRemove = (fileNameToRemove) => {
    const datasetsUpdated = data_.structured_datasets.filter(
      (dataset) => dataset.fileName !== fileNameToRemove
    );
    deleteDataset(
      `structured_datasets_${data.nodeId}`,
      JSON.stringify(datasetsUpdated)
    );
    deleteDataset(
      `columnTypes_${data.nodeId}`,
      JSON.stringify({
        ...Object.keys(data_.columnTypes).reduce((acc, key) => {
          if (key !== fileNameToRemove) {
            acc[key] = data_.columnTypes[key];
          }
          return acc;
        }, {}),
      })
    );

    deleteDataset(
      `unstructured_ColumnTypes_${data.nodeId}`,
      JSON.stringify({
        ...Object.keys(data_.unstructuredColumnTypes).reduce((acc, key) => {
          if (key !== fileNameToRemove) {
            acc[key] = data_.unstructuredColumnTypes[key];
          }
          return acc;
        }, {}),
      })
    );
    deleteDataset(`dataset_${data.nodeId}`, "");
    setData((prevData) => ({
      ...prevData,
      structured_datasets: datasetsUpdated,
      columnTypes: {
        ...Object.keys(prevData.columnTypes).reduce((acc, key) => {
          if (key !== fileNameToRemove) {
            acc[key] = prevData.columnTypes[key];
          }
          return acc;
        }, {}),
      },
      unstructuredColumnTypes: {
        ...Object.keys(prevData.unstructuredColumnTypes).reduce((acc, key) => {
          if (key !== fileNameToRemove) {
            acc[key] = prevData.unstructuredColumnTypes[key];
          }
          return acc;
        }, {}),
      },
      headers: [],
      structured_file: [],
    }));

    data.setBotData((prevData) => ({
      ...prevData,
      structured_datasets: datasetsUpdated,
      columnTypes: {
        ...Object.keys(prevData.columnTypes).reduce((acc, key) => {
          if (key !== fileNameToRemove) {
            acc[key] = prevData.columnTypes[key];
          }
          return acc;
        }, {}),
      },
      unstructuredColumnTypes: {
        ...Object.keys(prevData.unstructuredColumnTypes).reduce((acc, key) => {
          if (key !== fileNameToRemove) {
            acc[key] = prevData.unstructuredColumnTypes[key];
          }
          return acc;
        }, {}),
      },
      headers: [],
      structured_file: [],
    }));

    setCsvData((prevCsvData) => {
      const updatedCsvData = { ...prevCsvData };
      delete updatedCsvData[fileNameToRemove];
      return updatedCsvData;
    });
    setColumnTypes((prevColumnTypes) => {
      const updatedColumnTypes = { ...prevColumnTypes };
      delete updatedColumnTypes[fileNameToRemove];
      return updatedColumnTypes;
    });

    if (dataset === fileNameToRemove) {
      setDataset(
        data.botData?.structured_datasets?.length > 0
          ? data.botData.structured_datasets[0].fileName
          : ""
      );
    }

    setResetInput(true);
    // Set it back to false after a short delay
    setTimeout(() => setResetInput(false), 100);
  };

  const handleOpenSideBar = useCallback((infotype, event) => {
    event.stopPropagation(); // Prevent event from bubbling up to ReactFlow
    scroll();
    updateLocalStorage("open_sidebar", "true");
    updateLocalStorage("type", infotype);
  }, []);
  const scroll = () => {
    setTimeout(() => {
      const closeButton = document.querySelector("#btn-close-sidebar");
      if (closeButton) {
        closeButton.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const handleChangeCSV = (direction) => {
    if (direction === "back" && currentFileNumber > 0) {
      const ds = data_?.structured_datasets?.[currentFileNumber - 1]?.fileName;
      setCurrentFileNumber(currentFileNumber - 1);
      setDataset(ds);

      const confid = data_.structured_datasets.filter(
        (d) => d.fileName === ds
      )[0].confidentiality;
      const newConfid = confid;
      setVisibility(newConfid);
    } else if (
      direction === "forward" &&
      currentFileNumber < data_?.structured_datasets?.length - 1
    ) {
      const ds = data_?.structured_datasets?.[currentFileNumber + 1]?.fileName;
      setCurrentFileNumber(currentFileNumber + 1);
      setDataset(ds);
      saveDataset(`dataset_${data.nodeId}`, ds);
      const confid = data_.structured_datasets.filter(
        (d) => d.fileName === ds
      )[0].confidentiality;
      const newConfid = confid;
      setVisibility(newConfid);
    } else if (direction === "back" && currentFileNumber === 0) {
      setCurrentFileNumber(data_.structured_datasets.length - 1);
      setDataset(
        data_?.structured_datasets?.[data_.structured_datasets.length - 1]
          ?.fileName
      );
      saveDataset(
        `dataset_${data.nodeId}`,
        data_?.structured_datasets?.[data_.structured_datasets.length - 1]
          ?.fileName
      );
    } else if (
      direction === "forward" &&
      currentFileNumber === data_?.structured_datasets?.length - 1
    ) {
      const ds = data_?.structured_datasets?.[0]?.fileName;
      setCurrentFileNumber(0);
      setDataset(ds);
      saveDataset(`dataset_${data.nodeId}`, ds);

      const confid = data_.structured_datasets.filter(
        (d) => d.fileName === ds
      )[0].confidentiality;
      const newConfid = confid;
      setVisibility(newConfid);
    }
  };

  const handleConfidelectClick = () => {
    const open_cofid = openConfid;
    setOpenConfid(!openConfid);
    if (open_cofid) {
      confidRef.current.focus();
    }
  };

  const handleDTelectClick = () => {
    const open_dt = openDT;
    setOpenDT(!openDT);
    if (open_dt) {
      confidDTRef.current.focus();
    }
  };

  const onUploadUrl = async () => {
    if (!isValid) return;

    if (organization?.organization?.subscription === "starter") {
      if (urls.length >= 1) {
        setError("Starter plan allows only one URL.");
        return;
      }
      if (depth && depth > 5) {
        setError("Starter plan allows max depth of 5.");
        return;
      }
    }

    const key = `datasets_${data.nodeId}`;
    const uniqueId = generateID(8) + "_" + urls.length;

    const newDataset = {
      filedata: "",
      id: uniqueId,
      fileName: newUrl,
      fileType: "url",
      creationDate: getCurrentDate(),
      category: "",
      confidentiality: confid,
      scrapper: true,
      depth: depth,
    };

    const updatedDatasets = [...data_.datasets, newDataset];
    await saveDataset(key, JSON.stringify(updatedDatasets));

    const parsingKey = `parsing_instructions_${data.nodeId}`;
    const existingInstructions = JSON.parse(
      localStorage.getItem(parsingKey) || "{}"
    );

    // Add new entry for the uploaded URL
    const updatedInstructions = {
      ...existingInstructions,
      [newUrl]: {
        bounding_box: "0,0,0,0",
        mode: "auto",
        title_page_number: "1",
        exclude_title_page: false,
      },
    };

    localStorage.setItem(parsingKey, JSON.stringify(updatedInstructions));

    data.setBotData((prevData) => ({
      ...prevData,
      datasets: updatedDatasets,
      parsing_instructions: updatedInstructions,
    }));

    setData((prevData) => ({
      ...prevData,
      datasets: updatedDatasets,
      parsing_instructions: updatedInstructions,
    }));

    setUrls([...urls, newUrl]);
    setNewUrl("");
    setDepth("");

    data.showSnackbar("URL uploaded successfully", "success");
  };

  const openPromptDialog = () => {
    setIsPromptDialogOpen(true);
  };

  const closePromptDialog = () => {
    setIsPromptDialogOpen(false);
  };

  return (
    <Box sx={{ ...nodeStyles, ...datasetNodeStyles }}>
      {" "}
      <Box sx={hidden ? topNavNodeHidden : topNavNode}>
        <Typography sx={childNodeNavText}>Upload Dataset</Typography>
        <div>
          <InfoOutlined
            onClick={(event) => handleOpenSideBar("datasets", event)}
          />
        </div>
      </Box>
      <Box sx={{ ...nodeInputStyles, ...fileNodeInputStyles }}>
        <Box sx={selectCustomstyles}>
          <Box sx={{ width: "100%" }}>
            {uploadDatasetLoading && <LinearProgress />}
          </Box>
          <Box sx={inputsFileFolderStyles}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              onClick={handleDTelectClick}
              sx={{
                marginTop: 4,
                color: "white",
                borderColor: "white",
                outline: "white",
              }}
              data-tour="option-1c"
            >
              <InputLabel
                sx={inputSelectStyles.label}
                id="llm-select-confidDT-label"
                onClick={handleDTelectClick}
              >
                Upload dataset type
              </InputLabel>
              <Select
                inputRef={confidDTRef}
                labelId="llm-select-confidDT-label"
                label="Upload dataset type"
                value={dataType}
                onChange={handleChangeDT}
                onClick={handleDTelectClick}
                open={openDT}
                onClose={() => setOpenDT(false)}
                sx={inputSelectStyles.select}
                MenuProps={inputSelectStyles.selectMenuProps}
              >
                <MenuItem
                  key={datasetTypes[0].value}
                  value={datasetTypes[0].value}
                  disabled={
                    datasetTypes[0].value === "Structured" &&
                    data_.structured_datasets.filter((file) =>
                      file.fileName.includes("_unstructured")
                    ).length > 0
                      ? true
                      : false
                  }
                  onClick={(event) => {
                    event.stopPropagation();
                    handleChangeDT(event);
                  }}
                >
                  <Tooltip
                    placement="left"
                    title="A structured dataset is organized into a clear format, like rows and columns in a csv, spreadsheet or database, making it easy to search and analyze."
                  >
                    Tabular data{" "}
                    <img
                      src={csvIcon}
                      width={20}
                      alt=""
                      style={{ filter: "invert(100%)" }}
                    />{" "}
                    <img
                      src={excelIcon}
                      width={20}
                      alt=""
                      style={{ filter: "invert(100%)" }}
                    />
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  key={datasetTypes[1].value}
                  value={datasetTypes[1].value}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleChangeDT(event);
                  }}
                >
                  <Tooltip
                    placement="left"
                    title="An unstructured dataset is a bunch of data that doesn't follow a specific format or pattern, like random text files, PDFs, Word files, markdown files etc."
                  >
                    Text data{" "}
                    <img
                      src={txtIcon}
                      width={20}
                      style={{ filter: "invert(100%)" }}
                    />{" "}
                    <img
                      src={pdfIcon}
                      width={20}
                      style={{ filter: "invert(100%)" }}
                    />{" "}
                    <img
                      src={docx}
                      width={20}
                      style={{ filter: "invert(100%)" }}
                    />{" "}
                    <img
                      src={markdown}
                      width={15}
                      style={{ filter: "invert(100%)" }}
                    />
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  sx={{
                    "&.Mui-disabled": {
                      pointerEvents: "auto",
                    },
                  }}
                  key={
                    organization?.organization?.subscription === "starter" ||
                    (data_.structured_datasets.length > 0 &&
                      !(
                        data_.structured_datasets.filter((file) =>
                          file.fileName.includes("_unstructured")
                        ).length > 0
                      ))
                      ? ""
                      : datasetTypes[2].value
                  }
                  value={
                    organization?.organization?.subscription === "starter" ||
                    (data_.structured_datasets.length > 0 &&
                      !(
                        data_.structured_datasets.filter((file) =>
                          file.fileName.includes("_unstructured")
                        ).length > 0
                      ))
                      ? ""
                      : datasetTypes[2].value
                  }
                  disabled={
                    organization?.organization?.subscription === "starter" ||
                    (data_.structured_datasets.length > 0 &&
                      !(
                        data_.structured_datasets.filter((file) =>
                          file.fileName.includes("_unstructured")
                        ).length > 0
                      ))
                      ? true
                      : false
                  }
                  onClick={(event) => {
                    const check =
                      organization?.organization?.subscription === "starter" ||
                      (data_.structured_datasets.length > 0 &&
                        !(
                          data_.structured_datasets.filter((file) =>
                            file.fileName.includes("_unstructured")
                          ).length > 0
                        ))
                        ? true
                        : false;

                    if (check) {
                      return;
                    } else if (!check) {
                      event.stopPropagation();
                      handleChangeDT(event);
                    }
                  }}
                >
                  <Tooltip
                    placement="left"
                    title={
                      organization?.organization?.subscription === "starter"
                        ? "You need Queryloop Pro account to access this feature."
                        : "It refers to data that lacks a clear format but includes additional information (metadata) about it, like tags or descriptions, to help organize and understand the data better."
                    }
                  >
                    Text data with tags{" "}
                    <img
                      src={csvIcon}
                      width={20}
                      style={{ filter: "invert(100%)" }}
                    />{" "}
                    <img
                      src={excelIcon}
                      width={20}
                      style={{ filter: "invert(100%)" }}
                    />
                  </Tooltip>
                </MenuItem>

                <MenuItem
                  key={datasetTypes[3].value}
                  value={datasetTypes[3].value}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleChangeDT(event);
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    minHeight: 0,
                  }}
                >
                  <Tooltip
                    placement="left"
                    title="Extract data from a webpage URL"
                  >
                    <span
                      style={{
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                      }}
                    >
                      Website Scraper{" "}
                      <img
                        src={urlIcon}
                        style={{
                          width: 18,
                          height: 18,
                          filter: "invert(100%)",
                        }}
                      />{" "}
                    </span>
                  </Tooltip>
                </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              onClick={handleConfidelectClick}
              sx={{
                marginTop: 4,
                color: "white",
                borderColor: "white",
                outline: "white",
              }}
              data-tour="option-1d"
            >
              <InputLabel
                id="llm-select-label"
                onClick={handleConfidelectClick}
                sx={inputSelectStyles.label}
              >
                Confidentiality for files to select
              </InputLabel>
              <Select
                inputRef={confidRef}
                labelId="llm-select-label"
                label="Confidentiality for files to select"
                value={confid}
                onChange={handleChangeGlobal}
                onClick={handleConfidelectClick}
                open={openConfid}
                onClose={() => setOpenConfid(false)}
                sx={inputSelectStyles.select}
                MenuProps={inputSelectStyles.selectMenuProps}
              >
                <MenuItem
                  key={confidentialityOptions?.[0]?.value}
                  value={confidentialityOptions?.[0]?.value}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleChangeGlobal(event);
                  }}
                >
                  Public
                </MenuItem>
                <MenuItem
                  key={confidentialityOptions?.[1]?.value}
                  value={confidentialityOptions?.[1]?.value}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleChangeGlobal(event);
                  }}
                >
                  Confidential
                </MenuItem>
                <MenuItem
                  key={confidentialityOptions?.[2]?.value}
                  value={confidentialityOptions?.[2]?.value}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleChangeGlobal(event);
                  }}
                >
                  Secret
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
          {dataType === "Structured" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
                alignItems: "center",
              }}
            >
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                onClick={handleText2NoSQLSelectClick}
                sx={{ marginTop: 2 }}
              >
                <InputLabel
                  id="text2nosql-select-label"
                  sx={inputSelectStyles.label}
                  onClick={handleText2NoSQLSelectClick}
                >
                  Text-to-NoSQL Options
                </InputLabel>
                <Select
                  inputRef={text2NoSQLSelectRef}
                  labelId="text2nosql-select-label"
                  label="Text-to-NoSQL Options"
                  value={selectedText2NoSQLOption}
                  onChange={handleText2NoSQLChange}
                  onClick={handleText2NoSQLSelectClick}
                  open={isText2NoSQLSelectOpen}
                  onClose={() => setIsText2NoSQLSelectOpen(false)}
                  sx={inputSelectStyles.select}
                  MenuProps={inputSelectStyles.selectMenuProps}
                >
                  <MenuItem
                    value="similaritySearch"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleText2NoSQLChange(event);
                    }}
                  >
                    Use Similarity Search Only
                  </MenuItem>

                  <MenuItem
                    value="text2nosql"
                    disabled={isText2NoSQLOptionDisabled}
                    onClick={(event) => {
                      event.stopPropagation();
                      handleText2NoSQLChange(event);
                    }}
                    sx={{
                      opacity: isText2NoSQLOptionDisabled ? 0.5 : 1,
                    }}
                  >
                    Use Text-to-NoSQL Only
                  </MenuItem>

                  <MenuItem
                    value="both"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleText2NoSQLChange(event);
                    }}
                  >
                    Use Text-to-NoSQL with Similarity Search
                  </MenuItem>
                </Select>
              </FormControl>
              <EditNote
                onClick={openPromptDialog}
                sx={{ cursor: "pointer", marginTop: 2 }}
                fontSize="medium"
              />
            </Box>
          )}
          {/* upload btns */}
          {dataType !== "url_scraper" && (
            <Box sx={inputsFileFolderCustomStyles}>
              {/* input btn for upload files */}
              <CustomInput
                resetInput={resetInput}
                ref={fileInputRef}
                placeholder={"Upload Files"}
                type={"file"}
                upload_type={
                  dataType === "Unstructured"
                    ? "unstructured"
                    : dataType === "Unstructured with metadata"
                    ? "unstructured-meta"
                    : "structured"
                }
                multiple={true}
                onHandleChange={
                  dataType === "Unstructured" ||
                  dataType === "Unstructured with metadata"
                    ? handleUpload
                    : handleUploadStructured
                }
              />
              {/* input btn for upload folder */}
              <CustomInput
                resetInput={resetInput}
                ref={folderInputRef}
                placeholder={"Upload Folder"}
                type={"file"}
                upload_type={
                  dataType === "Unstructured"
                    ? "folder-unstructured"
                    : dataType === "Unstructured with metadata"
                    ? "folder-unstructured-meta"
                    : "folder-structured"
                }
                multiple={true}
                onHandleChange={(e) => {
                  dataType === "Unstructured"
                    ? handleFolderUpload(e, "unstructured")
                    : dataType === "Unstructured with metadata"
                    ? handleFolderUpload(e, "unstructured-with-metadata")
                    : handleFolderUpload(e, "structured");
                }}
              />
            </Box>
          )}

          {dataType === "url_scraper" && (
            <Box
              sx={{
                flexDirection: "row",
                alignItems: "center",
                mt: 3,
                width: "100%",
                gap: 2,
              }}
            >
              <TextField
                label="Enter URL for Scraping"
                variant="outlined"
                fullWidth
                value={newUrl}
                onChange={handleChangeUrl}
                error={!!error}
                helperText={error}
                sx={{
                  ...inputSelectStyles.textField,
                  width: "56%",
                  mr: 2,
                  "& .MuiFormHelperText-root": {
                    whiteSpace: "nowrap",
                    mx: 0,
                  },
                  "& .MuiInputLabel-root": {
                    color: theme.inputs.textColor,
                    fontSize: "13px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {validateUrlLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CheckCircle
                          sx={{
                            color: isValid ? "green" : "white",
                          }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Enter max pages"
                variant="outlined"
                value={depth}
                onChange={handleChangeUrlDepth}
                sx={{
                  ...inputSelectStyles.textField,
                  width: "36%",
                  "& .MuiInputLabel-root": {
                    color: theme.inputs.textColor,
                    fontSize: "13px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        title={
                          <div style={{ maxWidth: "300px" }}>
                            <strong>Max Pages Parameter:</strong>
                            <ul
                              style={{ paddingLeft: "16px", margin: "8px 0" }}
                            >
                              <li>
                                Controls the total number of pages the scraper
                                will extract.
                              </li>
                              <li>
                                Setting it to <strong>1</strong> extracts only
                                the provided URL.
                              </li>
                              <li>
                                Setting it to <strong>2</strong> extracts one
                                additional linked page.
                              </li>
                              <li>
                                Leaving it empty (default) enables unlimited
                                crawling.
                              </li>
                            </ul>
                            <strong>Note</strong>: Higher values may increase
                            crawl time & server load.Set an appropriate limit
                            based on your data needs.
                          </div>
                        }
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          sx={{ color: "white" }}
                        />
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          )}
          <p id="info">
            {dataType === "Structured" &&
              "*Supported file types: .csv/.xlsx (Excel format)"}
            {dataType === "Unstructured" &&
              "*Supported file types: .pdf. .docx, .txt, .md"}
            {dataType === "Unstructured with metadata" &&
              "*Supported file types: .csv (for metadata definition)"}
            {dataType === "url_scraper" &&
              "*Supported: URLs must start with http:// or https:// and contain HTML content"}
          </p>
          <Box sx={viewDatasetsStyles}>
            <Button
              data-tour="option-1e"
              sx={{
                ...secondaryButtonStyles,
                padding: "2px 8px",
                marginTop: "20px",
              }}
              onClick={() => {
                setVisibility(
                  data_?.structured_datasets?.find(
                    (f) => f.fileName === dataset
                  )?.confidentiality
                );
                setOpenDatasetModal(true);
              }}
            >
              View Datasets
            </Button>
            {dataType === "url_scraper" && (
              <Button
                sx={{
                  ...primaryButtonStyles,
                  marginTop: "20px",
                  ml: 2,
                  padding: "2px 8px",
                }}
                onClick={onUploadUrl}
                disabled={!isValid}
              >
                Upload URL
              </Button>
            )}
            <Typography
              sx={{ ...inputSelectStyles.informationText, marginBottom: 0 }}
            >
              *
              {`${
                data_?.datasets?.filter((dataset) => !dataset.scrapper)
                  ?.length + data_?.structured_datasets?.length || 0
              } dataset${
                data_?.datasets?.filter((dataset) => !dataset.scrapper)
                  ?.length +
                  data_?.structured_datasets?.length ===
                1
                  ? ""
                  : "s"
              }, ${
                data_?.datasets?.filter((dataset) => dataset.scrapper)
                  ?.length || 0
              } link${
                data_?.datasets?.filter((dataset) => dataset.scrapper)
                  ?.length === 1
                  ? ""
                  : "s"
              } uploaded`}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openDatasetModal}
        onClose={() => setOpenDatasetModal(false)}
        PaperProps={{ sx: dialogStyles.dialogRoot }}
      >
        <DialogTitle sx={dialogStyles.dialogTitle}>
          <Clear
            onClick={() => setOpenDatasetModal(false)}
            sx={dialogStyles.dialogCloseIcon}
          />
        </DialogTitle>
        <Box
          sx={{
            padding: 2,
            bgcolor: colors.extremeBlue,
            display: "flex",
            flexDirection: "column",
            height: size === "full" ? "100%" : "auto",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "thin", // Firefox scrollbar width
            scrollbarColor: "rgba(68, 61, 255, 0.5) transparent", // Firefox scrollbar color

            "&::-webkit-scrollbar": {
              width: "10px", // Scrollbar width
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(68, 61, 255, 0.7)", // Scrollbar color
              borderRadius: "10px", // Rounded scrollbar
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent", // Hide scrollbar track background
            },
          }}
        >
          {/* Unstructured Data Accordion */}
          <Box sx={{ mb: 2 }}>
            <Accordion
              defaultExpanded={data_.datasets.length > 0}
              sx={{
                bgcolor: colors.secondaryBlue,
                color: colors.extremeWhite,
                borderRadius: "4px",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: colors.extremeWhite }} />}
              >
                <Typography>
                  Unstructured datasets without Metadata &nbsp;&nbsp;
                  {data_?.datasets?.filter((dataset) => !dataset.scrapper)
                    ?.length > 0
                    ? `(${
                        data_?.datasets?.filter((dataset) => !dataset.scrapper)
                          ?.length
                      })`
                    : ""}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  bgcolor: colors.extremeBlue,
                  border: `1px solid ${colors.secondaryBlue}`,
                  color: colors.extremeWhite,
                }}
              >
                {data_?.datasets?.filter((dataset) => !dataset.scrapper)
                  ?.length > 0 ? (
                  <Box
                    sx={{
                      my: 2,
                    }}
                  >
                    {data_?.datasets
                      ?.filter((dataset) => !dataset.scrapper)
                      ?.map((file, index) => (
                        <Box
                          key={file.fileName}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: "#333",
                            padding: 1,
                            marginBottom: 1,
                            borderRadius: "4px",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ color: colors.extremeWhite }}
                          >
                            {file.fileName}
                          </Typography>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <FormControl
                              size="small"
                              key={`Confidentiality_${file.id}_${index}`}
                              id={`Confidentiality_${file.id}_${index}`}
                            >
                              <Select
                                id={`Confidentiality_${file.id}_${index}`}
                                value={
                                  data_.datasets.find(
                                    (f) => f.fileName === file.fileName
                                  ).confidentiality
                                }
                                onChange={(e) =>
                                  handleChange_unstructured_confidentiality(
                                    e,
                                    file.fileName
                                  )
                                }
                                sx={selectBaseStyles}
                                MenuProps={{
                                  PaperProps: {
                                    sx: { ...menuContainerStyles },
                                  },
                                }}
                              >
                                <MenuItem sx={menuItemStyles} value="Public">
                                  Public
                                </MenuItem>
                                <MenuItem
                                  sx={menuItemStyles}
                                  value="Confidential"
                                >
                                  Confidential
                                </MenuItem>
                                <MenuItem sx={menuItemStyles} value="Secret">
                                  Secret
                                </MenuItem>
                              </Select>
                            </FormControl>

                            <Button
                              onClick={() =>
                                handleFileRemove(file.id, file.fileName)
                              }
                              sx={{ color: colors.extremeWhite }}
                            >
                              X
                            </Button>
                          </Box>
                        </Box>
                      ))}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: colors.extremeWhite,
                    }}
                  >
                    <Typography variant="body1">
                      No unstructured data uploaded
                    </Typography>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>

          {/* Structured Data Accordion */}
          <Box sx={{ mb: 2 }}>
            <Accordion
              defaultExpanded={Object.keys(csvData)?.length > 0}
              sx={{
                bgcolor: colors.secondaryBlue,
                color: colors.extremeWhite,
                borderRadius: "4px",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: colors.extremeWhite }} />}
              >
                <Typography>
                  {data_.structured_datasets.filter((file) =>
                    file.fileName.includes("_unstructured")
                  ).length > 0
                    ? "Unstructured datasets with Metadata"
                    : "Structured Datasets"}
                  &nbsp;&nbsp;
                  {Object.keys(csvData)?.length > 0
                    ? `(${Object.keys(csvData)?.length})`
                    : ""}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  bgcolor: colors.extremeBlue,
                  border: `1px solid ${colors.secondaryBlue}`,
                  color: colors.extremeWhite,
                }}
              >
                {Object.keys(csvData).length === 0 ? (
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: colors.extremeWhite,
                    }}
                  >
                    <Typography variant="body1">
                      No structured data uploaded
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    {Object.keys(csvData)?.length > 0 && (
                      <Box sx={{ mb: 2, flexDirection: "row" }}>
                        <Typography variant="body2" sx={{ color: "white" }}>
                          Select Dataset
                        </Typography>
                        <FormControl fullWidth size="small">
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Select
                              id="datasetName"
                              value={dataset}
                              onChange={handleChangeDataset}
                              sx={selectBaseStyles}
                              fullWidth
                              MenuProps={{
                                PaperProps: {
                                  sx: { ...menuContainerStyles },
                                },
                              }}
                            >
                              {data_?.structured_datasets?.map((d, index) => (
                                <MenuItem
                                  key={index}
                                  id={index}
                                  value={d.fileName}
                                  sx={menuItemStyles}
                                >
                                  {d.fileName}
                                </MenuItem>
                              ))}
                            </Select>
                            <Tooltip title="Delete Selected Dataset">
                              <Button
                                onClick={() =>
                                  handleStructuredFileRemove(dataset)
                                }
                                sx={{ color: colors.extremeWhite }}
                              >
                                <Delete />
                              </Button>
                            </Tooltip>
                            {data_.structured_datasets.filter((file) =>
                              file.fileName.includes("_unstructured")
                            ).length > 0 && (
                              <Button
                                variant="contained"
                                style={btnStyles}
                                onClick={handleGenerateMetadata}
                                disabled={generateMetadataLoading}
                              >
                                {generateMetadataLoading ? (
                                  <CircularProgress />
                                ) : (
                                  "Generate Metadata Description"
                                )}
                              </Button>
                            )}
                          </Box>
                        </FormControl>
                      </Box>
                    )}

                    {Object.keys(csvData)?.[0] &&
                      Object.keys(csvData)?.length > 0 && (
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="body2" sx={{ color: "white" }}>
                            Confidentiality
                          </Typography>
                          <FormControl fullWidth size="small">
                            <Select
                              id="Confidentiality"
                              value={
                                data_?.structured_datasets?.find(
                                  (f) => f.fileName === dataset
                                )?.confidentiality || visibility
                              }
                              onChange={handleChange}
                              sx={selectBaseStyles}
                              MenuProps={{
                                PaperProps: {
                                  sx: { ...menuContainerStyles },
                                },
                              }}
                            >
                              <MenuItem sx={menuItemStyles} value="Public">
                                Public
                              </MenuItem>
                              <MenuItem
                                sx={menuItemStyles}
                                value="Confidential"
                              >
                                Confidential
                              </MenuItem>
                              <MenuItem sx={menuItemStyles} value="Secret">
                                Secret
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      )}

                    <TableContainer sx={tableContainerStyles}>
                      <Table>
                        <TableHead>
                          {csvData[dataset] && csvData[dataset].length > 0 && (
                            <>
                              <TableRow>
                                {(
                                  Object.keys(csvData?.[dataset]?.[0]) || {}
                                )?.map(
                                  (header, index) =>
                                    header !== "" &&
                                    !/^_\d+$/.test(header) && (
                                      <TableCell
                                        key={index}
                                        sx={{
                                          ...tableCellStyleHeader,
                                          height: "120px",
                                          justifyContent: "start",
                                          alignItems: "start",
                                        }}
                                      >
                                        <select
                                          value={
                                            columnTypes?.[dataset]?.[header]
                                          }
                                          onChange={(e) =>
                                            handleColumnTypeChange(
                                              dataset,
                                              header,
                                              e.target.value
                                            )
                                          }
                                          style={{
                                            borderRadius: "5px",
                                            padding: "4px",
                                            backgroundColor:
                                              colors.extremeWhite,
                                            border: `1px solid ${colors.primaryBlue}`,
                                            color: colors.extremeBlack,
                                            cursor: "pointer",
                                          }}
                                        >
                                          <option value="Metadata column">
                                            Metadata column
                                          </option>
                                          <option value="Text column">
                                            Text column
                                          </option>
                                        </select>
                                        <br />
                                        {columnTypes?.[dataset]?.[header] ===
                                          "Metadata column" &&
                                        data_.structured_datasets.filter(
                                          (file) =>
                                            file.fileName.includes(
                                              "_unstructured"
                                            )
                                        ).length > 0 ? (
                                          <Tooltip title="Click on Generate metadata descriptions">
                                            <Input
                                              inputRef={textAreaRef}
                                              key={header}
                                              name={header}
                                              onChange={(e) =>
                                                handleChangeMetadataDescription(
                                                  e,
                                                  header
                                                )
                                              }
                                              type="text"
                                              rows={1}
                                              sx={inputStyles}
                                              placeholder="Click on Generate metadata descriptions"
                                              value={
                                                data_?.metadataDescription?.[
                                                  dataset
                                                ]?.[header]?.["description"]
                                              }
                                            />
                                          </Tooltip>
                                        ) : (
                                          <br />
                                        )}
                                        <br />
                                        <select
                                          defaultValue={
                                            data_?.structured_datasets?.find(
                                              (_d) => _d?.fileName === dataset
                                            )?.dataTypes?.[header] ||
                                            "undefined"
                                          }
                                          onChange={(event) =>
                                            handleDataTypeChange(
                                              event,
                                              header,
                                              dataset
                                            )
                                          }
                                          style={{
                                            borderRadius: "5px",
                                            padding: "4px",
                                            backgroundColor:
                                              colors.extremeWhite,
                                            border: `1px solid ${colors.primaryBlue}`,
                                            color: colors.extremeBlack,
                                            cursor: "pointer",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <option
                                            value={
                                              data_?.structured_datasets?.find(
                                                (_d) => _d?.fileName === dataset
                                              )?.dataTypes?.[header] ===
                                              "object"
                                                ? "String"
                                                : data_?.structured_datasets?.find(
                                                    (_d) =>
                                                      _d?.fileName === dataset
                                                  )?.dataTypes?.[header]
                                            }
                                          >
                                            {data_?.structured_datasets?.find(
                                              (_d) => _d?.fileName === dataset
                                            )?.dataTypes?.[header] === "object"
                                              ? "String"
                                              : data_?.structured_datasets?.find(
                                                  (_d) =>
                                                    _d?.fileName === dataset
                                                )?.dataTypes?.[header]}
                                          </option>
                                          <option value="Integer">
                                            Integer
                                          </option>
                                          <option value="Float">Float</option>
                                          <option value="String">String</option>
                                          <option value="Boolean">
                                            Boolean
                                          </option>
                                          <option value="List">List</option>
                                          <option value="Null">Null</option>
                                          <option value="Undefined">
                                            Undefined
                                          </option>
                                          <option value="Symbol">Symbol</option>
                                          <option value="datetime64">
                                            DateTime
                                          </option>
                                        </select>
                                      </TableCell>
                                    )
                                )}
                              </TableRow>

                              <TableRow>
                                {csvData?.[dataset] &&
                                  Object.keys(
                                    csvData?.[dataset]?.[0] || {}
                                  )?.map(
                                    (header, index) =>
                                      header !== "" &&
                                      !/^_\d+$/.test(header) && (
                                        <TableCell
                                          sx={tableCellStyleHeader}
                                          key={index}
                                        >
                                          {header}
                                        </TableCell>
                                      )
                                  )}
                              </TableRow>
                            </>
                          )}
                        </TableHead>
                        <TableBody>
                          {csvData?.[dataset]?.map(
                            (row, rowIndex) =>
                              rowIndex !== 0 && (
                                <TableRow key={rowIndex}>
                                  {Object?.values(row)?.map(
                                    (value, cellIndex) =>
                                      value !== "" && (
                                        <TableCell
                                          key={cellIndex}
                                          sx={tableCellStyleBody}
                                        >
                                          {value.length < 30 ? (
                                            value
                                          ) : (
                                            <Tooltip
                                              title={value}
                                              placement="top"
                                            >
                                              {" "}
                                              {value
                                                .toString()
                                                .substring(0, 30) + "..."}
                                            </Tooltip>
                                          )}
                                        </TableCell>
                                      )
                                  )}
                                </TableRow>
                              )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <p className="total-csvs">
                        Total Files: {data_?.structured_datasets?.length}
                      </p>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={() => handleChangeCSV("back")}
                          sx={btnStyles}
                        >
                          {"< Prev"}&nbsp;
                        </Button>
                        <Typography sx={{ mx: 1 }}>
                          {currentFileNumber + 1}
                        </Typography>
                        <Button
                          onClick={() => handleChangeCSV("forward")}
                          sx={btnStyles}
                        >
                          &nbsp;{"Next >"}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>

          {/* URLs Data Accordion */}
          <Box>
            <Accordion
              defaultExpanded={data_.datasets.length > 0}
              sx={{
                bgcolor: colors.secondaryBlue,
                color: colors.extremeWhite,
                borderRadius: "4px",
                mb: 4,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: colors.extremeWhite }} />}
              >
                <Typography>
                  URLs&nbsp;&nbsp;
                  {data_?.datasets?.filter((dataset) => dataset.scrapper)
                    ?.length > 0
                    ? `(${
                        data_?.datasets?.filter((dataset) => dataset.scrapper)
                          ?.length
                      })`
                    : ""}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  bgcolor: colors.extremeBlue,
                  border: `1px solid ${colors.secondaryBlue}`,
                  color: colors.extremeWhite,
                }}
              >
                {data_?.datasets?.filter((dataset) => dataset.scrapper)
                  ?.length > 0 ? (
                  <Box
                    sx={{
                      my: 2,
                    }}
                  >
                    {data_?.datasets
                      ?.filter((dataset) => dataset.scrapper)
                      ?.map((file, index) => (
                        <Box
                          key={file.fileName}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: "#333",
                            padding: 1,
                            marginBottom: 1,
                            borderRadius: "4px",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ color: colors.extremeWhite }}
                          >
                            {file.fileName}{" "}
                            {file.depth !== "" && `(Depth: ${file.depth})`}
                          </Typography>

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <FormControl
                              size="small"
                              key={`Confidentiality_${file.id}_${index}`}
                              id={`Confidentiality_${file.id}_${index}`}
                            >
                              <Select
                                id={`Confidentiality_${file.id}_${index}`}
                                value={
                                  data_.datasets.find(
                                    (f) => f.fileName === file.fileName
                                  ).confidentiality
                                }
                                onChange={(e) =>
                                  handleChange_unstructured_confidentiality(
                                    e,
                                    file.fileName
                                  )
                                }
                                sx={selectBaseStyles}
                                MenuProps={{
                                  PaperProps: {
                                    sx: { ...menuContainerStyles },
                                  },
                                }}
                              >
                                <MenuItem sx={menuItemStyles} value="Public">
                                  Public
                                </MenuItem>
                                <MenuItem
                                  sx={menuItemStyles}
                                  value="Confidential"
                                >
                                  Confidential
                                </MenuItem>
                                <MenuItem sx={menuItemStyles} value="Secret">
                                  Secret
                                </MenuItem>
                              </Select>
                            </FormControl>

                            <Button
                              onClick={() =>
                                handleFileRemove(file.id, file.fileName)
                              }
                              sx={{ color: colors.extremeWhite }}
                            >
                              X
                            </Button>
                          </Box>
                        </Box>
                      ))}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: colors.extremeWhite,
                    }}
                  >
                    <Typography variant="body1">No URLs uploaded</Typography>
                  </Box>
                )}
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
      </Dialog>
      {/* Text2NoSQl Prompt Dialog */}
      <TextToNoSQLDialog
        isPromptDialogOpen={isPromptDialogOpen}
        closePromptDialog={closePromptDialog}
        data={data}
      />
      <Dialog
        open={isConfirmationDialogOpen}
        // open={true}
        onClose={() => handleConfirmationDialogClose(false)}
        PaperProps={{ sx: dialogStyles.dialogRoot }}
      >
        <DialogTitle sx={dialogStyles.dialogTitle}>
          Change to a Supported Option
        </DialogTitle>
        <DialogContent sx={{ ...dialogStyles.dialogContent, mt: 2 }}>
          You have uploaded multiple structured files. Only "Similarity Search"
          and "Text-to-NoSQL with Similarity Search" are available. The option
          will change to "Text-to-NoSQL with Similarity Search" by default. Do
          you want to continue?
        </DialogContent>
        <DialogActions sx={{ bgcolor: colors.extremeBlue }}>
          <Button
            onClick={() => handleConfirmationDialogClose(false)}
            sx={btnStyles}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleConfirmationDialogClose(true)}
            sx={btnStyles}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
export default UploadDatasetsNode;
